import SideBar from "../sidebar/sideBar";
import Header from "../header/header";

const ReportsComponent = () => {
  return (
    <div className="flex  bg-black main">
      <SideBar />
      <div className="h-full  flex flex-col content-center  w-full">
        <Header />
      </div>
    </div>
  );
};

export default ReportsComponent;
